// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"141":"1c069ecd","281":"47399f95","419":"72c2efae","501":"46159819","638":"30f8a6f2","967":"70554917"}[chunkId] + ".css";
};